import { render, staticRenderFns } from "./Dev.vue?vue&type=template&id=233e7f85&scoped=true"
import script from "./Dev.vue?vue&type=script&lang=js"
export * from "./Dev.vue?vue&type=script&lang=js"
import style0 from "./Dev.vue?vue&type=style&index=0&id=233e7f85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233e7f85",
  null
  
)

export default component.exports